import React, { FC, memo } from 'react';
import cn from 'classnames';
import { TReportTableProps } from 'domains/ReportBuilder/types';
import TableFilter from 'components/UI/TableFilter';
import { addSpacesForIntegers } from 'domains/ReportBuilder/utils';
import css from './styles.module.scss';
import { useReportTable } from './useReportTable';

const ReportTable: FC<TReportTableProps> = ({
  columns,
  data,
  handleSort,
  tableSort,
  statistics
}) => {
  const { tableMinWidth, template, handleResizeStart, tableWidth } =
    useReportTable({
      columns,
    });

  return (
    <div className={css.wrapper}>
      <div
        className={css.table}
        style={{
          width: tableWidth,
          minWidth: tableMinWidth,
        }}
      >
        <div
          className={css.header}
          style={{
            gridTemplateColumns: template,
          }}
        >
          {columns.map((column) => (
            <div
              key={column.id}
              className={cn(css.headerCell, {
                _isResize: column.grow,
              })}
            >
              <TableFilter
                data={column.id}
                title={column.title}
                activeKey={tableSort && tableSort.key}
                sort={tableSort && tableSort.sort}
                handleSort={handleSort}
                isShow
              />
              {column.grow && (
                <div
                  className={css.resizeHandle}
                  onMouseDown={(e) => handleResizeStart(e, column)}
                />
              )}
            </div>
          ))}
        </div>

        <div className={css.body}>
          {data.map((row, index) => (
            <div
              key={String(row.id)}
              className={cn(css.row, {
                _isGray: index % 2 === 0,
              })}
              style={{
                gridTemplateColumns: template,
              }}
            >
              {columns.map((column) => (
                <div
                  key={column.id}
                  className={cn(css.cell, {
                    _isResize: column.grow,
                  })}
                  title={String(row[column.id])}
                >
                  <span>
                    {addSpacesForIntegers(
                      row[column.id] as number,
                      column.id,
                      statistics.map((stat) => stat.value),
                    )}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(ReportTable);
